// 登月规则配置
import React, { useEffect, useState } from 'react';
import Microapp from '@/components/micro-app';
import env from '@/env';
// 主题活动会场
import { data as defaultData } from '../../constants';
// 我的创建
import createData from '@/pages/activity-manage/my-create/constants/data';
// 新版日常活动
import dailyData from '@/pages/activity-manage/my-create/daily-activities-details-manager/material-pool-manage/material-collection-daily/my-micro-app/data';
// 频道列表
import channelServiceData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/constants/data';
// 阵地资源位，行业频道
import { platformData, industryData } from '@/pages/platform-marketing-position/resource-detail/contants/data';

import { updateCrumbs } from '@/components/bread-crumbs';

const allEnvData = { avenueData: defaultData, channelServiceData, createData, dailyData, platformData, industryData };

function PoolList(props: any) {
  const { data = defaultData, ..._props } = props;
  const [subCrumbs, _updateCrumbs] = useState(null);

  useEffect(() => {
    if (!subCrumbs) return;
    // 离开当前页面清除面包屑的数据
    return updateCrumbs({ subCrumbs });
  }, [subCrumbs]);

  return (
    <Microapp
      data={{ ...allEnvData, ...data, updateCrumbs: _updateCrumbs }}
      // http://mcbeta.jd.com/dist/pages/activeManageBlock/?entry=0&activityId=10599231
      url={`${env.MC_DOMAIN}/manage/`}
      name="mcmanage"
      {..._props}
    />
  );
}

const routeItem = {
  path: '/managemc/*',
  title: '',
  getCrumb(context: any = {}) {
    const { crumb, breadCrumbs } = context;

    if (!breadCrumbs) return;
    if (!breadCrumbs.subCrumbs) return;

    return breadCrumbs.subCrumbs.map((item: any) => {
      return {
        title: item.title,
        path: crumb.path.slice(0, -2) + item.path + location.search,
      };
    });
  },
};

export { routeItem };

export default PoolList;
